import PersonIcon from '@mui/icons-material/Person';
import { Button, Typography } from '@mui/material';
const PORTAL_URL = '/book-an-appointment/user-portal';
interface IWelcomeBackBanner {
  firstName: string | null;
}
export default function WelcomeBackBanner({
  firstName
}: Readonly<IWelcomeBackBanner>) {
  const label = firstName ? `Welcome back, ${firstName}!` : 'Welcome back';
  return <Button data-testid="welcome-back-banner" onClick={() => globalThis.window.location.href = PORTAL_URL} sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    textTransform: 'none',
    color: 'text.interactive',
    p: 0,
    minWidth: 'unset',
    '&:hover': {
      bgcolor: 'transparent',
      textDecoration: 'underline'
    }
  }} data-sentry-element="Button" data-sentry-component="WelcomeBackBanner" data-sentry-source-file="WelcomeBackBanner.tsx">
			<PersonIcon fontSize="small" data-testid="welcome-back-banner-icon" data-sentry-element="PersonIcon" data-sentry-source-file="WelcomeBackBanner.tsx" />
			<Typography variant="bodySmallBook" color="text.interactive" data-testid="welcome-back-banner-label" data-sentry-element="Typography" data-sentry-source-file="WelcomeBackBanner.tsx">
				{label}
			</Typography>
		</Button>;
}